import { useQuery } from '@tanstack/react-query';

import { getTeamsAndUsersCount } from '../queries/getTeamsAndUsersCount';

export const useGetTeamWiseUserCount = (): {
  teamWiseUserCount: { [key: string]: number };
  isLoading: boolean;
  error: Error | null;
} => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['team-wise-user-count'],
    queryFn: () => getTeamsAndUsersCount(),
  });
  const teamWiseUserCount: { [key: string]: number } = {};
  data?.teamsAndUsersCount.forEach((team) => {
    // TODO: move BC Experience to separate client
    if (team.team_name === 'BC Experience') {
      return;
    }
    teamWiseUserCount[team.team_name] = team.distinct_user_count;
  });
  return { teamWiseUserCount, isLoading, error };
};
